import { render, staticRenderFns } from "./K2Upload.vue?vue&type=template&id=6aec3731"
import script from "./K2Upload.vue?vue&type=script&lang=js"
export * from "./K2Upload.vue?vue&type=script&lang=js"
import style0 from "./K2Upload.vue?vue&type=style&index=0&id=6aec3731&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports